import { usePromotedTrackingData } from 'src/app/shared/hooks/promotion';

import { usePetitionDetails } from '../petitionDetails';

export function usePromotedTrackingDataForCurrentPetition(): ReturnType<typeof usePromotedTrackingData> {
	const { id } = usePetitionDetails();
	return usePromotedTrackingData(id);
}
